module.exports = __webpack_public_path__ + "static/media/auth-eva.743790ae.png";